export default __webpack_public_path__ + "static/media/Corner avoidance setup.6f230aac.jpg";